module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Music-cloud-1f06984351da2015f2816e9204eeb179.svg";